import { getAmpConfig } from 'src/services/amp-config.service';

export enum Environments {
  local = 'local',
  devci = 'devci',
  staging = 'staging',
  prod = 'prod',
}

export const getEnv = (): Environments => getAmpConfig().env as Environments;

export const isLocalEnvByUrl = () => {
  const url = window.location.hostname;

  return url.includes('local.amplify.com');
};

export const REVISION_ALIAS = '2021-2022';

export const JOIN_URLS = {
  [Environments.local]: 'https://student.amplify.com/join/',
  [Environments.devci]: 'https://student-devci.poc.learning.amplify.com/join/',
  [Environments.staging]:
    'https://student-staging.stage.learning.amplify.com/join/',
  [Environments.prod]: 'https://student.amplify.com/join/',
};

export const getJoinUrl = (): string => {
  const env = getEnv();
  return JOIN_URLS[env];
};
